import { render, staticRenderFns } from "./TemplateAbbreviationWidget.vue?vue&type=template&id=69559bcc&"
import script from "./TemplateAbbreviationWidget.vue?vue&type=script&lang=ts&"
export * from "./TemplateAbbreviationWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports